import { useContext, useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { FirebaseContext } from '@/session/FirebaseContext';
import { ACTIVE_TOURNAMENT } from '@/constants';
import { getFixturesFromJson, type Fixture } from '@/models/fixture';

/** Live WC-26 fixtures from Firestore when available; bundled JSON as fallback. */
export function useWc26Fixtures(): Fixture[] {
  const ctx = useContext(FirebaseContext);
  const [fixtures, setFixtures] = useState<Fixture[]>(() => getFixturesFromJson());

  useEffect(() => {
    return onSnapshot(
      query(
        collection(ctx.db, 'competitions', ACTIVE_TOURNAMENT, 'fixtures'),
        orderBy('date', 'asc'),
        orderBy('sortOrder', 'asc'),
      ),
      (snapshot) => {
        const loaded = snapshot.docs.map((doc) => doc.data() as Fixture);
        if (loaded.length > 0) {
          setFixtures(loaded);
        }
      },
      (error) => {
        console.error(error);
      },
    );
  }, [ctx.db]);

  return fixtures;
}
